export type Route =
    | "LOGIN"
    | "RESET_PASSWORD"
    | "USER_NOT_FOUND"
    | "NETWORK_ERROR"
    | "LOCAL_DEV_NETWORK_ERROR"
    | "MAINTENANCE"
    | "HOME"
    | "CLIENTS"
    | "CLIENT_CAMPAIGNS"
    | "CLIENT_MASTER_TEMPLATES"
    | "CLIENT_FONTS"
    | "CAMPAIGN"
    | "CAMPAIGN_EDITOR"
    | "CAMPAIGN_LIBRARY"
    | "CAMPAIGN_CONNECT"
    | "SANDBOX"
    | "PAGE_NOT_FOUND";

export const AppRoute = {
    LOGIN: "/login",
    RESET_PASSWORD: "/reset-password/:username?",

    USER_NOT_FOUND: "/user-not-found",
    NETWORK_ERROR: "/network-error",
    LOCAL_DEV_NETWORK_ERROR: "/local-dev-network-error",
    MAINTENANCE: "/maintenance",

    HOME: "/",
    CLIENTS: "/",
    CLIENT_CAMPAIGNS: "/client/:clientId",
    CLIENT_MASTER_TEMPLATES: "templates",
    CLIENT_FONTS: "fonts",

    CAMPAIGN: "campaign/:campaignId",
    CAMPAIGN_EDITOR: "editor",
    CAMPAIGN_LIBRARY: "library",
    CAMPAIGN_CONNECT: "connect",

    SANDBOX: "/sandbox",

    PAGE_NOT_FOUND: "/:pathMatch(.*)*"
} as const;

export const AppRouteNames = {
    LOGIN: "Login",
    RESET_PASSWORD: "Reset Password",
    USER_NOT_FOUND: "UserNotFound",
    NETWORK_ERROR: "NetworkError",
    LOCAL_DEV_NETWORK_ERROR: "LocalDevNetworkError",
    MAINTENANCE: "Maintenance",
    HOME: "Home",
    CLIENTS: "Clients",
    CLIENT_CAMPAIGNS: "CampaignsDashboard",
    CLIENT_MASTER_TEMPLATES: "ClientTemplates",
    CLIENT_FONTS: "Fonts",
    CAMPAIGN: "Campaign",
    CAMPAIGN_EDITOR: "CampaignEditor",
    CAMPAIGN_LIBRARY: "CampaignLibrary",
    CAMPAIGN_CONNECT: "Connect",
    SANDBOX: "Sandbox",
    PAGE_NOT_FOUND: "PageNotFound"
} as const;
